import $axios from '~/plugins/axios';
import { buildModule } from '../utils';
import { Api, SettingPrinterRequest } from '~/api';

const api = $axios as Api;

export default buildModule()
	.withActions({
		async post (_, body: SettingPrinterRequest) {
			await api.post('/setting/printer', body);
		},
		async update (_, { id, ...body }: { id: number } & SettingPrinterRequest) {
			await api.put(`/setting/printer/${ id }`, body);
		},
	});
